import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { injectStyle } from 'react-toastify/dist/inject-style';
import './styles.scss';

if (typeof window !== 'undefined') {
  injectStyle();
}

const ToastContent = ({ autoClose }) => {
  const contextClass = {
    success: 'bg-blue-500',
    error: 'bg-red-600',
    info: 'bg-gray-600',
    warning: 'bg-orange-400',
    default: 'bg-gray-800',
    dark: 'bg-gray-800 font-gray-300',
  };

  const fadeIn = cssTransition({
    enter: 'fade-in-top',
    exit: 'fade-out-bottom',
  });

  return (
    <ToastContainer
      className="Toast flex flex-col items-center justify-center"
      toastClassName={({ type }) =>
        `${
          contextClass[type || 'default']
        } relative flex px-8 py-6 mb-4 rounded-md justify-between overflow-hidden cursor-pointer xm:mx-10 xm:py-5 xm:px-7 xm:mt-4`
      }
      bodyClassName={() => 'flex items-center mr-1 leading-8'}
      position="top-center"
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      transition={fadeIn}
      role="alert"
      autoClose={autoClose}
    />
  );
};

ToastContent.propTypes = {
  autoClose: PropTypes.number,
};

ToastContent.defaultProps = {
  autoClose: 3000,
};

export default ToastContent;
